import { BehaviourSettingServices } from './../../../../../services/BehaviourSetting.services'
import { Component, HostListener, OnDestroy, OnInit } from '@angular/core'

@Component({
    selector: 'app-modal-behavior-setting-form-in-timeline',
    templateUrl: './modal-behavior-setting-form-in-timeline.component.html',
    styleUrls: [
        './modal-behavior-setting-form-in-timeline.component.css',
        '../../../../../stagingcss/main-body.component.css',
        '../../../../../stagingcss/lui-select.component.css',
        '../../../../../stagingcss/root-ui-view.component.css',
        '../../../../../stagingcss/main-view.component.css',
    ],
})
export class ModalBehaviorSettingFormInTimelineComponent implements OnInit, OnDestroy {

    isShowModalTimeline: any = 'hidden'
    title: any = ''
    deleted: any
    roomTag: any
    arrTimeline: any[] = []
    jsonTimeline: any = {}
    arrElementTimeline: any[] = []
    firstElement: any[] = []
    levelMultiIndex: any = 2
    level: any = 2
    id: any
    index: any
    arrAll: any[] = []
    firstArrAll: any[] = []

    view: any = 'form-in-timeline'

    tabArray: any

    IsActiveModalFormInTimeline: any
    emitArrFormSetting: any
    emitIdentifyTimeline: any
    jsonBehaviorSetting: any = {}

    tagsFormTimeline: any = {}

    arrSaveTags: any[] = []
    arrayConvert: any[] = []
    updateArrAll

    constructor(
        private behaviourSettingServices: BehaviourSettingServices,
    ) {
    }

    ngOnInit() {
        this.arrSaveTags = []
        this.IsActiveModalFormInTimeline = this.behaviourSettingServices.changeEmittedIsActiveModalFormInTimeline$.subscribe(status => {
            if (status != null && status != undefined && status['status'] != undefined) {
                this.isShowModalTimeline = status['status']
            }
        })
        this.get()
        // this.getArrAll();
        this.getArrElement()
    }

    getArrAll() {
        this.updateArrAll = this.behaviourSettingServices.changeEmittedArrFormSetting$.subscribe(arr => {
            if (arr != null && arr != undefined && arr['arrFormSetting'] != undefined && arr['option'] != 'timeline') {
                this.arrAll = arr['arrFormSetting']
            }
        })
    }

    ngOnDestroy() {
        if(this.IsActiveModalFormInTimeline)
            this.IsActiveModalFormInTimeline.unsubscribe()
        if(this.emitArrFormSetting)
            this.emitArrFormSetting.unsubscribe()
        if(this.emitIdentifyTimeline)
            this.emitIdentifyTimeline.unsubscribe()
        // this.updateArrAll.unsubscribe();
    }

    activeTag(id) {
        const check = this.arrSaveTags.findIndex(el => {
            return el == id
        })
        if (check == -1) {
            this.arrSaveTags.push(id)
        } else {
            this.arrSaveTags.splice(check, 1)
        }
    }

    getClassTags(id) {
        const check = this.arrSaveTags.findIndex(el => {
            return el == id
        })
        if (check != -1) {
            return true
        }
        return false
    }

    @HostListener('document:keydown', ['$event']) handleKeyboardEvent(event: KeyboardEvent) {
        const keyPressed = event.keyCode
        const showView: any = this.behaviourSettingServices.returnView()
        if (showView != '' && showView == this.view) {
            if (keyPressed === 27) {
                if (event) {
                    event.preventDefault()
                }
                this.closeModal()
            } else if (keyPressed == 13) {
                event.preventDefault()
            }
        }
    }

    getArrElement() {
        this.emitArrFormSetting = this.behaviourSettingServices.changeEmittedArrFormSetting$.subscribe(jsonRes => {
            if (jsonRes && this.tabArray == jsonRes['option']) {
                // this.tabArray = jsonRes['option'];
                if (jsonRes && jsonRes['arrFormSetting']) {
                    this.arrAll = jsonRes['arrFormSetting']
                    if (Array.isArray(this.arrAll)) {
                        this.arrElementTimeline = this.arrAll.filter(function(el) {
                            return el && el['level'] == 1
                        })
                    } else {
                        this.arrElementTimeline = []
                    }
                }
            }
        })
    }

    recursiveData(data, level, parent) {
        if (data && data.length > 0) {
            data.forEach((el, i) => {
                el['level'] = level
                if (el['schema'] && el['schema']['items']) {
                    const arrayProperty: any[] = el['schema']['items']['properties']
                    this.recursiveData(arrayProperty, level + 1, el['propertyName'])
                }
                const find = this.arrayConvert.find(item => {
                    return item['propertyName'] == el['propertyName']
                })
                if (!find) {
                    el['parent'] = parent
                    this.arrayConvert.push(el)
                }
            })
        }
    }

    convertArray(jsonRes) {
        const arrayRes: any[] = jsonRes['properties']
        const level = 1
        this.arrayConvert = []
        if (arrayRes) {
            arrayRes.forEach((el, i) => {
                el['level'] = level
                if (el['schema'] && el['schema']['items']) {
                    const arrayProperty: any[] = el['schema']['items']['properties']
                    this.recursiveData(arrayProperty, level + 1, el['propertyName'])
                }
                const find = this.arrayConvert.find(item => {
                    return item['propertyName'] == el['propertyName']
                })
                if (!find) {
                    this.arrayConvert.push(el)
                }
            })
        }
        return this.arrayConvert
    }

    get() {
        this.emitIdentifyTimeline = this.behaviourSettingServices.changeEmittedIdentifyTimeline$.subscribe(indentify => {
            this.jsonBehaviorSetting = this.behaviourSettingServices.returnJsonBehaviorSetting()
            this.tagsFormTimeline = (this.jsonBehaviorSetting && this.jsonBehaviorSetting['json']) ? this.jsonBehaviorSetting['json']['noteTag'] : []
            if (indentify != null && indentify != undefined && indentify['id'] != undefined) {
                this.id = indentify['id']
                this.arrAll = []
                const arr = this.behaviourSettingServices.returnArrTimeline()
                // this.behaviourSettingServices.changeEmittedArrTimeline$.subscribe(arr => {
                if (arr != null && arr != undefined && arr['timeline'] != undefined) {
                    this.arrTimeline = arr['timeline']
                    this.tabArray = arr['option']
                    if (this.arrTimeline.length > 0) {
                        this.index = this.arrTimeline.findIndex(el => {
                            return el['_id'] == this.id
                        })
                        this.jsonTimeline = this.arrTimeline[this.index]
                        if (this.jsonTimeline != undefined) {
                            this.title = this.jsonTimeline['title'] != undefined ? this.jsonTimeline['title'] : ''
                            this.arrSaveTags = this.jsonTimeline['tags'] ? this.jsonTimeline['tags'] : []
                            this.roomTag = this.jsonTimeline['room'] != undefined ? this.jsonTimeline['room'] : ''
                            this.deleted = this.jsonTimeline['deleted'] != undefined ? this.jsonTimeline['deleted'] : false
                            const tmpJson = this.jsonTimeline['schema'] != undefined ? this.jsonTimeline['schema'] : {}
                            this.firstElement = []
                            this.arrAll = []
                            this.firstArrAll = []
                            const tmpArrarConvert = this.convertArray(tmpJson)
                            this.arrAll = jQuery.extend(true, [], tmpArrarConvert)
                            this.firstArrAll = $.extend(true, [], this.arrAll)
                            this.arrElementTimeline = this.arrAll.filter(function(el) {
                                return el['level'] == 1
                            })
                            const emitArr: any = {}
                            emitArr['arrFormSetting'] = this.arrAll
                            emitArr['option'] = 'timelineForms'
                            this.behaviourSettingServices.emitChangeArrFormSetting(emitArr)
                        }
                    }
                }
                // });
            }
        })
    }

    addItem() {
        const newItem: any = {}
        newItem['conditionTarget'] = ''
        newItem['isCondition'] = false
        newItem['isListField'] = false
        newItem['propertyName'] = new Date().getTime().toString()
        newItem['schema'] = {}
        newItem['title'] = ''
        newItem['type'] = ''
        newItem['level'] = 1
        this.arrElementTimeline.push(newItem)
        this.arrAll.push(newItem)
        const emitArr: any = {}
        emitArr['arrFormSetting'] = this.arrAll
        emitArr['option'] = 'timelineForms'
        this.behaviourSettingServices.emitChangeArrFormSetting(emitArr)
    }

    resetArray(arrayUndo: any[], lengthUndo) {
        const item = arrayUndo[0]
        if (item) {
            if (item.level != 1) {
                if (typeof item.level != 'undefined') {
                    delete item.level
                }
                if (typeof item.parent != 'undefined') {
                    delete item.parent
                }
                arrayUndo.splice(0, 1)
                const findIndex = arrayUndo.findIndex(function(el, i) {
                    return el['propertyName'] == item['propertyName']
                })
                const findItem = arrayUndo[findIndex]
                if (findItem) {
                    if (findItem && findItem['schema'] && findItem['schema']['items'] && findItem['schema']['items']['properties']) {
                        const arrProperties: any[] = findItem['schema']['items']['properties']
                        if (arrProperties && arrProperties.length > 0) {
                            const replaceElementIndex = arrProperties.findIndex(function(el, i) {
                                return el['propertyName'] == item['propertyName']
                            })
                            if (replaceElementIndex != -1) {
                                arrProperties[replaceElementIndex] = item
                                findItem['schema']['items']['properties'] = arrProperties
                            }
                        } else {
                            delete findItem.schema.items['properties']
                        }
                    }
                    if (findItem && findItem['schema'] && findItem['schema']['options']) {
                        const tmpOptions: any[] = findItem['schema']['options']
                        if (tmpOptions.length == 0) {
                            delete findItem.schema['options']
                        } else if (tmpOptions.length == 1) {
                            const itemOption = tmpOptions[0]
                            if (itemOption['title'] == '') {
                                delete findItem.schema['options']
                            }
                        }
                    }
                    if (findItem && findItem['schema'] && findItem['schema']['uiOptions'] && findItem['schema']['uiOptions']['behavior'] == '') {
                        delete findItem.schema['uiOptions']
                    }
                    if (findItem && findItem['schema'] && findItem['schema']['uiConditionType'] == null) {
                        delete findItem.schema['uiConditionType']
                    }
                    if (findItem && findItem['schema'] && findItem['schema']['uiType'] == null) {
                        delete findItem.schema['uiType']
                    }
                    arrayUndo[findIndex] = findItem
                }
                this.resetArray(arrayUndo, lengthUndo)
            }
        } else {
            arrayUndo.splice(0, 1)
            this.resetArray(arrayUndo, lengthUndo)
        }
        return arrayUndo
    }

    undoArrayAllSetting(arrayAll: any[]) {
        const tmpArrayLevelZero = arrayAll.filter(function(el, i) {
            return el['level'] == 1
        })
        const lengthUndoArray = tmpArrayLevelZero.length
        if (lengthUndoArray > 0) {
            arrayAll.sort(function(a, b) {
                return b['level'] - a['level']
            })
            const undoArray: any[] = this.resetArray(arrayAll, lengthUndoArray)
            undoArray.forEach(function(el, i) {
                if (el) {
                    if (typeof el.level != 'undefined') {
                        delete el.level
                    }
                    if (typeof el.parent != 'undefined') {
                        delete el.parent
                    }
                    if (el['schema'] && el['schema']['items'] && el['schema']['items']['properties']) {
                        const arrProperties: any[] = el['schema']['items']['properties']
                        if (arrProperties && arrProperties.length == 0) {
                            delete el.schema.items['properties']
                        }
                    }
                    if (el['schema'] && el['schema']['options']) {
                        const tmpOptions: any[] = el['schema']['options']
                        if (tmpOptions.length == 0) {
                            delete el.schema['options']
                        } else if (tmpOptions.length == 1) {
                            const itemOption = tmpOptions[0]
                            if (itemOption['title'] == '') {
                                delete el.schema['options']
                            }
                        }
                    }
                    if (el['schema'] && el['schema']['uiConditionType'] == null) {
                        delete el.schema['uiConditionType']
                    }
                    if (el['schema'] && el['schema']['uiType'] == null) {
                        delete el.schema['uiType']
                    }
                    if (el['schema'] && el['schema']['uiOptions'] && el['schema'] && el['schema']['uiOptions']['behavior'] == '') {
                        delete el.schema['uiOptions']
                    }
                    undoArray[i] = el
                }
            })
            return undoArray
        }
        return []
    }

    onSave() {
        const undo = this.undoArrayAllSetting(this.arrAll)
        const tmpSchema: any = {}
        tmpSchema['properties'] = undo
        tmpSchema['type'] = 'object'
        const thi = this
        const findIndex = this.arrTimeline.findIndex(function(el) {
            return el['_id'] == thi.id
        })
        const tmpTimeline = this.arrTimeline[findIndex]
        tmpTimeline['schema'] = tmpSchema
        tmpTimeline['tags'] = this.arrSaveTags
        tmpTimeline['title'] = this.title
        tmpTimeline['deleted'] = this.deleted

        this.arrTimeline[findIndex] = tmpTimeline
        const emitArr = {}
        emitArr['timeline'] = this.arrTimeline
        emitArr['option'] = this.tabArray
        this.behaviourSettingServices.emitChangeArrTimeline(emitArr)

        const emitActiveModal: any = {}
        emitActiveModal['status'] = 'hidden'
        this.behaviourSettingServices.emitChangeIsActiveModalFormInTimeline(emitActiveModal)
        const emitView: any = {}
        emitView['view'] = 'form-setting'
        this.behaviourSettingServices.emitChangeView(emitView)
        this.arrAll = []
    }

    removeJson() {
        this.jsonTimeline['title'] = ''
        this.jsonTimeline['room'] = ''
        this.jsonTimeline['deleted'] = false
        this.jsonTimeline['schema'] = []
        this.arrTimeline[this.index] = this.jsonTimeline
        const emit: any = {}
        emit['timeline'] = this.arrTimeline
        this.behaviourSettingServices.emitChangeArrTimeline(emit)
        const emitActiveModal: any = {}
        emitActiveModal['status'] = 'hidden'
        this.behaviourSettingServices.emitChangeIsActiveModalFormInTimeline(emitActiveModal)
    }

    openModal(propertyName) {
        const emitState: any = {}
        emitState['state'] = 'new'
        this.behaviourSettingServices.emitChangeState(emitState)
        const emitDetailForm: any = {}
        this.levelMultiIndex = propertyName
        const status: any = 'statusDetailForm-' + this.levelMultiIndex
        emitDetailForm[status] = 'active'
        this.behaviourSettingServices.emitChangeStatusDetailFormSetting(emitDetailForm)
        const countLevel: any = {}
        countLevel['identify'] = this.levelMultiIndex
        this.behaviourSettingServices.emitChangeCountLevel(countLevel)

        const emitLevel: any = {}
        emitLevel['level'] = this.level
        this.behaviourSettingServices.emitChangeLevel(emitLevel)
        const emitOldId: any = {}
        emitOldId['oldId'] = propertyName
        this.behaviourSettingServices.emitChangeOldId(emitOldId)
        const emitView: any = {}
        emitView['view'] = 'form-in-timeline'
        this.behaviourSettingServices.emitChangeView(emitView)
    }

    moveUp(index: any) {
        const nextIndex: any = index - 1
        if (nextIndex >= 0) {
            const jsonIndex = this.arrElementTimeline.find((el, i) => {
                return i == index
            })
            const jsonNextIndex = this.arrElementTimeline.find((el, i) => {
                return i == nextIndex
            })
            this.arrElementTimeline[index] = jsonNextIndex
            this.arrElementTimeline[nextIndex] = jsonIndex

            const findIndexItem = this.arrAll.findIndex(el => {
                return el['propertyName'] == jsonIndex['propertyName']
            })

            const findIndexNextItem = this.arrAll.findIndex(el => {
                return el['propertyName'] == jsonNextIndex['propertyName']
            })

            this.arrAll[findIndexItem] = jsonNextIndex
            this.arrAll[findIndexNextItem] = jsonIndex
        }
    }

    moveDown(index: any) {
        const nextIndex: any = index + 1
        if (nextIndex < this.arrElementTimeline.length) {
            const jsonIndex = this.arrElementTimeline.find((el, i) => {
                return i == index
            })
            const jsonNextIndex = this.arrElementTimeline.find((el, i) => {
                return i == nextIndex
            })
            this.arrElementTimeline[index] = jsonNextIndex
            this.arrElementTimeline[nextIndex] = jsonIndex

            const findIndexItem = this.arrAll.findIndex(el => {
                return el['propertyName'] == jsonIndex['propertyName']
            })

            const findIndexNextItem = this.arrAll.findIndex(el => {
                return el['propertyName'] == jsonNextIndex['propertyName']
            })

            this.arrAll[findIndexItem] = jsonNextIndex
            this.arrAll[findIndexNextItem] = jsonIndex
        }
    }

    remove(index) {
        const json: any = this.arrElementTimeline[index]
        this.arrElementTimeline.splice(index, 1)
        const findIndex = this.arrAll.findIndex(el => {
            return el['propertyName'] == json['propertyName']
        })
        if (findIndex != -1) {
            this.arrAll.splice(findIndex, 1)
        }
        const emitArr: any = {}
        emitArr['arrFormSetting'] = this.arrAll
        emitArr['option'] = this.tabArray
        this.behaviourSettingServices.emitChangeArrFormSetting(emitArr)
    }

    closeModal() {
        const undo = this.undoArrayAllSetting(this.firstArrAll)
        const tmpSchema: any = {}
        tmpSchema['properties'] = undo
        tmpSchema['type'] = 'object'
        const thi = this
        const findIndex = this.arrTimeline.findIndex(function(el) {
            return el['_id'] == thi.id
        })
        const tmpTimeline = this.arrTimeline[findIndex]
        tmpTimeline['schema'] = tmpSchema
        tmpTimeline['title'] = this.title
        this.arrTimeline[findIndex] = tmpTimeline
        const emitArr = {}
        emitArr['timeline'] = this.arrTimeline
        emitArr['option'] = this.tabArray
        this.behaviourSettingServices.emitChangeArrTimeline(emitArr)

        this.isShowModalTimeline = 'hidden'
        const emit: any = {}
        emit['status'] = 'hidden'
        this.behaviourSettingServices.emitChangeIsActiveModalFormInTimeline(emit)
        const emitView: any = {}
        emitView['view'] = 'form-setting'
        this.behaviourSettingServices.emitChangeView(emitView)
        this.arrAll = []
        this.firstArrAll = []
    }
}



// WEBPACK FOOTER //
// ./src/app/app_manager/modal/setting/behavior/modal-behavior-setting-form-in-timeline/modal-behavior-setting-form-in-timeline.component.ts